export function processString(data: string | undefined | null) {
  if (!data) return "N/A";
  return data;
}

